export default __webpack_public_path__ + "static/media/feature-monitoring-1.86b1f5f7.png";